import { render, staticRenderFns } from "./OrderSingleSummaryShipping.vue?vue&type=template&id=583e9ab9&"
import script from "./OrderSingleSummaryShipping.vue?vue&type=script&lang=js&"
export * from "./OrderSingleSummaryShipping.vue?vue&type=script&lang=js&"
import style0 from "./OrderSingleSummaryShipping.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports